/**
 * Update date: 28-03-2025
 * Screen 1046.B
 */
import React, { useState, useContext, createContext } from 'react';
import useAxios from 'axios-hooks';
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import useDictionary from 'hooks/useDictionary';
import ViewEditCreate from './ViewEditCreate';

const List = React.lazy(() => import('./List'));


/**
 * create context
 */
const MallLinkedTargetSettingContext = createContext({});

MallLinkedTargetSettingContext.displayName = 'Setting the target for linking with the mall';

export const useMallLinkedTargetSetting = () => {
  const context = useContext(MallLinkedTargetSettingContext);
  return context;
};

const MallLinkedTargetSetting = () => {
  const { t: translateFn }: any = useDictionary({});
  const t = typeof translateFn === 'function' ? translateFn : (text: string) => text; // fallback 설정

  const [data, setData] = useState([]);
  const [modeView, setModeView] = useState({
    type: 'list',
    mallInfoId: '',
  });
  console.log('🌟 modeView.type:', modeView?.type);

  const [{ loading: loadingfetchData }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  const value: any = {
    t,
    data,
    setData,
    refetchData,
    modeView,
    setModeView,
  };

  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List />;
      case 'edit':
        return <ViewEditCreate />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <MallLinkedTargetSettingContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loadingfetchData} />
        {renderContent()}
      </React.Suspense>
    </MallLinkedTargetSettingContext.Provider>
  );
};

export default MallLinkedTargetSetting;
